export default "__VITE_ASSET__f2ae9842__"